import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';

var HsePerson = /** @class */ (function (_super) {
    __extends(HsePerson, _super);
    function HsePerson() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({
            default: function () { return ({
                image: ''
            }); }
        }),
        __metadata("design:type", Object)
    ], HsePerson.prototype, "classes", void 0);
    __decorate([
        Prop({
            default: function () { return ({}); }
        }),
        __metadata("design:type", Object)
    ], HsePerson.prototype, "imgStyle", void 0);
    HsePerson = __decorate([
        Component({
            inheritAttrs: false
        })
    ], HsePerson);
    return HsePerson;
}(Vue));

export default HsePerson;
